<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    class="mb40"
    :pagination="pagination"
  >
    <template v-slot:bodyCell="{ column, record }">
      <template v-if="column.dataIndex == 'activityName'">
        <a-button type="link" @click="addActive(2, record)">{{
          record.activityName
        }}</a-button>
      </template>
      <!-- record, index -->
      <template v-if="column.dataIndex == 'time'"
        >{{ record.startTime }} - {{ record.endTime }}</template
      >
      <template v-if="column.dataIndex == 'status'">{{
        record.status === 1 ? '启用' : '禁用'
      }}</template>
      <template v-if="column.dataIndex == 'operate'">
        <a-button type="link" @click="addActive(1, record)">编辑</a-button>
        <a-button type="link" @click="updateStatus(record)">{{
          record.status === 1 ? '禁用' : '启用'
        }}</a-button>
      </template>
    </template>
  </a-table>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped></style>
